import { useEffect, useState, useSyncExternalStore } from 'react'

export function getErrorStatus(error: unknown): number {
	if (typeof error === 'object' && error !== null && 'status' in error) return getErrorStatus(error.status)
	if (typeof error === 'number') return error
	return 500
}

export function getErrorMessage(error: unknown) {
	if (error === undefined) return 'undefined'
	if (error === null) return 'null'
	if (typeof error === 'object' && error !== null && 'message' in error) return getErrorMessage(error.message)
	if (typeof error === 'string') return error
	try {
		return JSON.stringify(error)
	} catch {
		return String(error)
	}
}

export function pluralise(word: string, count: number) {
	return count === 1 ? word : `${word}s`
}

export function useHydrated() {
	return useSyncExternalStore(
		// @ts-ignore
		() => {},
		() => true,
		() => false,
	)
}

function useDebounce<T>(value: T, delay: number): [T, boolean] {
	const [debouncedValue, setDebouncedValue] = useState(value)
	let [isDebouncing, setDebouncing] = useState(false)

	useEffect(() => {
		setDebouncing(true)

		const handler = setTimeout(() => {
			setDebouncing(false)
			setDebouncedValue(value)
		}, delay)

		return () => clearTimeout(handler)
	}, [value, delay])

	return [debouncedValue, isDebouncing]
}

export { useDebounce }
